import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retryWhen, delay, take, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {}

  private handleError(error: any) {
    console.error('API Error from service:', error);
    return throwError(() => error);
  }

  private withRetry<T>(observable: Observable<T>): Observable<T> {
    return observable.pipe(
      retryWhen(errors => errors.pipe(
        delay(1000),  // 1s delay
         take(2)       // Retry 2 times
      )),
      catchError(this.handleError)
    );
  }

  get<T>(url: string, params?: any): Observable<T> {
    return this.withRetry(this.http.get<T>(url, { params }));
  }

  post<T>(url: string, data: any): Observable<T> {
    return this.withRetry(this.http.post<T>(url, data));
  }
 postEvent<T>(
  url: string,
  data: any,
  meta?: {
    headers?: HttpHeaders;
    params?: any;
    reportProgress?: boolean;
  }
): Observable<HttpEvent<T>> {

  const options = {
    ...meta,
    observe: 'events' as const,
    reportProgress: true
  };

  return this.withRetry(
    this.http.post<T>(url, data, options)
  );
}

  put<T>(url: string, data: any): Observable<T> {
    return this.withRetry(this.http.put<T>(url, data));
  }

  delete<T>(url: string, params?: any): Observable<T> {
    return this.withRetry(this.http.delete<T>(url, { params }));
  }
}
